import { List } from 'antd';
import type { ListGridType } from 'antd/es/list';
import React from 'react';

type Props<T> = {
  data: T[];
  renderItem: (item: T, idx: number) => React.ReactNode;
  bordered?: boolean;
  split?: boolean;
  grid?: ListGridType;
};

export const SList = <T extends object>({
  data,
  renderItem,
  bordered = false,
  split = true,
  grid,
}: Props<T>) => (
  <List
    grid={grid}
    dataSource={data}
    renderItem={renderItem}
    bordered={bordered}
    split={split}
  />
);
